function getTrainerDesc(trainer, params) {
  if (trainer) {
    switch(trainer.component) {
      case 'texts': 
        let mode = params.selected_mode.text
        return {
          'Текст': params.text_title,
          'Режим': mode
        }

      case 'spritz': 
        return {
          'Текст': params.text_title,
          'Скорость': params.speed,
        }

      case 'speedtest': 
        return {
          'Текст': params.text.title,
          'Таймер': params.countdownSeconds + 'сек.',
        }

      case 'bee': 
        if (params.mode === "where") {
          mode = 'Найди дракошу'
        }
        return {
          'Режим': mode,
          'Поле': params.size + ' x ' + params.size,
          'Шаги': params.min_steps,
          'Скорость': params.speed + 'сек.',
        }

      case 'strup': 
        mode = params.mode === 'words' ? 'Слова' : 'Таблица'
        return {
          'Режим': mode,
          'Шаги': params.steps,
          'Скорость': params.speed + 'сек.',
        }

      case 'alphabet': 
        mode = params.mode === 'words' ? 'Слова' : 'Таблица'
        return {
          'Режим': mode,
          'Шаги': params.steps,
          'Скорость': params.speed + 'сек.',
        }

      case 'wedge': 
        mode = params.mode === 'digits' ? 'Цифры' : 'Слова'
        return {
          'Режим': mode,
          'Размер': params.mode === 'digits' ? params.digits_count : params.letters_count,
          'Строки': params.rows,
          'Направление': params.orientation === 'column' ? 'верт.' : 'гориз.'
        }

      case 'metronom': 
        return {
          'Скорость': params.bpm,
          'Акценты': params.has_accent ? 'да' : 'нет',
        }

      case 'memo':
        return {
          'Карты': params.cards,
          'Подсказка': params.startTime + ' сек.',
          'Таймер': params.timer + ' сек.'
        }

      case 'shulte':
        return {
          'Режим': params.mode === 'digits' ? 'Цифры' : 'Буквы',
          'Счет': getShulteMode(params.direction),
          'Поле': params.size + ' x ' + params.size,
          'Поворот': params.rotate
        }

      case 'gorbov':
        return {
          'Поле': params.size + ' x ' + params.size,
        }

      case 'mnemo':
        return {
          'Поле': params.size + ' x ' + params.size,
        }
    }
  }
  
}

function getShulteMode(direction) {
  if (direction === 'direct') {
    return 'Прямой'
  }
  if (direction === 'reverse') {
    return 'Обратный'
  }
  if (direction === 'random') {
    return 'Случайный'
  }
}

export { getTrainerDesc }